/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Konvertuje broj telefona u internacionalni format bez razmaka i znaka "+".
 * Podržava unos tipa "064 123 4567", "+381 60 123 4567", "0038164...".
 * Vraća npr. "381641234567", ili "" ako broj nije upotrebljiv.
 */
export function toInternationalNumber(raw, defaultCountryCode = '381') {
  if (!raw) return '';
  let digits = String(raw).replace(/[^\d+]/g, ''); // ostavi samo cifre i +

  if (digits.startsWith('+')) {
    digits = digits.slice(1);
  } else if (digits.startsWith('00')) {
    digits = digits.slice(2);
  } else if (digits.startsWith('0')) {
    digits = defaultCountryCode + digits.slice(1);
  } else if (!digits.startsWith(defaultCountryCode)) {
    // Broj bez prefiksa i bez vodeće nule – pretpostavi domaću zemlju.
    digits = defaultCountryCode + digits;
  }

  return digits;
}
